module.exports = __webpack_public_path__ + "static/media/scarboroughbluffs.23ad7670.jpg";